<template>
  <v-row>
    <v-col cols="12" md="6">
      <v-autocomplete
        v-model="localSelected"
        :items="addressOptions"
        :filter="handleSearch"
        :return-object="true"
        :hide-details="true"
        :color="colorBnn['color-bnn']"
        ref="search"
        item-value="id"
        placeholder="ค้นหารหัสไปรษณีย์ เพื่อกรอกจังหวัด เขต/อำเภอ แขวง/ตำบล"
        class="text-sm"
        append-icon=""
        prepend-inner-icon="mdi-magnify"
        oninput="this.value=this.value.slice(0,5).replace(/[^\d]+/g, '')"
        inputmode="numeric"
        outlined
        background-color="white"
        @change="handleSelected"
      >
        <template v-slot:no-data>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="text-sm">
                ไม่พบข้อมูล
                กรุณาระบุและตรวจสอบรหัสไปรษณีย์ของคุณให้ถูกต้อง
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-autocomplete>
    </v-col>

    <div class="w-full"></div>

    <v-col cols="12" md="6" class="pb-0">
      <label class="mb-18">
        จังหวัด <span class="text-red">*</span>
      </label>
      <v-autocomplete
        v-model="localProvince"
        :color="colorBnn['color-bnn']"
        :items="provinceOptions"
        :error="errorProvince"
        ref="province"
        class="text-sm"
        background-color="white"
        placeholder="จังหวัด"
        @change="handleProvinceChange"
      ></v-autocomplete>
    </v-col>

    <v-col cols="12" md="6" class="pb-0">
      <label class="mb-18">
        เขต/อำเภอ <span class="text-red">*</span>
      </label>
      <v-autocomplete
        v-model="localDistrict"
        :items="districtOptions"
        :color="colorBnn['color-bnn']"
        :error="errorDistrict"
        ref="district"
        class="text-sm"
        background-color="white"
        placeholder="อำเภอ"
        @change="handleDistrictChange"
      ></v-autocomplete>
    </v-col>

    <v-col cols="12" md="6" class="pb-0">
      <label class="mb-18">
        แขวง/ตำบล <span class="text-red">*</span>
      </label>
      <v-autocomplete
        v-model="localSubDistrict"
        :items="subDistrictOptions"
        :color="colorBnn['color-bnn']"
        :error="errorSubDistrict"
        ref="subDistrict"
        class="text-sm"
        background-color="white"
        placeholder="ตำบล"
        @change="emitChange('subDistrict', localSubDistrict)"
      ></v-autocomplete>
    </v-col>

    <v-col cols="12" md="6" class="pb-0">
      <label class="mb-18">
        รหัสไปรษณีย์ <span class="text-red">*</span>
      </label>
      <v-text-field
        v-model="localPostcode"
        :color="colorBnn['color-bnn']"
        :error="errorPostcode"
        ref="postcode"
        type="text"
        placeholder="รหัสไปรษณีย์"
        class="text-sm"
        oninput="this.value=this.value.slice(0,5).replace(/[^\d]+/g, '')"
        inputmode="numeric"
        @change="emitChange('postcode', localPostcode)"
      />
    </v-col>
  </v-row>
</template>

<script>
import colorBnn from '@/config/color'

export default {
  props: {
    selected: {
      type: Object,
      default: null,
    },
    postcode: {
      type: String,
      default: '',
    },
    province: {
      type: String,
      default: '',
    },
    district: {
      type: String,
      default: '',
    },
    subDistrict: {
      type: String,
      default: '',
    },

    errorPostcode: {
      type: Boolean,
      default: false,
    },
    errorProvince: {
      type: Boolean,
      default: false,
    },
    errorDistrict: {
      type: Boolean,
      default: false,
    },
    errorSubDistrict: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      localSelected: null,

      localPostcode: this.postcode.toString(),
      localProvince: this.province,
      localDistrict: this.district,
      localSubDistrict: this.subDistrict,

      colorBnn,
    }
  },

  computed: {
    addressOptions() {
      return this.$store.getters[
        'thailandStore/addressSelectionByPostcode'
      ]
    },
    provinceOptions() {
      return this.$store.getters['thailandStore/fetchProvince']
    },
    districtOptions() {
      return this.$store.getters['thailandStore/fetchDistrict'](
        this.localProvince,
      )
    },
    districtOptionsTotal() {
      return this.districtOptions.length
    },
    subDistrictOptions() {
      return this.$store.getters['thailandStore/fetchSubDistrict'](
        this.localProvince,
        this.localDistrict,
      )
    },
    subDistrictOptionsTotal() {
      return this.subDistrictOptions.length
    },
  },

  watch: {
    postcode(value) {
      this.localPostcode = value.toString()
    },
    province(value) {
      this.localProvince = value
    },
    district(value) {
      this.localDistrict = value
    },
    subDistrict(value) {
      this.localSubDistrict = value
    },
  },

  methods: {
    handleSearch(item, queryText) {
      if (!queryText) {
        return false
      }

      return item.postcode
        .toString()
        .toLowerCase()
        .includes(queryText.toLowerCase())
    },
    handleSelected(value) {
      if (!value) {
        return
      }

      if (value) {
        this.localPostcode = value.postcode.toString()
        this.localProvince = value.province
        this.localDistrict = value.district
        this.localSubDistrict = value.subDistrict
      } else {
        this.localPostcode = ''
        this.localProvince = ''
        this.localDistrict = ''
        this.localSubDistrict = ''
      }

      this.emitChange('postcode', this.localPostcode)
      this.emitChange('province', this.localProvince)
      this.emitChange('district', this.localDistrict)
      this.emitChange('subDistrict', this.localSubDistrict)

      this.$nextTick(() => {
        this.localSelected = null
        this.$refs.search.blur()

        // scroll to the province field
        this.$refs.province.$el.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })
      })
    },
    handleProvinceChange(value) {
      this.localDistrict = ''
      this.localSubDistrict = ''
      this.localPostcode = ''

      this.emitChange('province', value)
      this.emitChange('district', '')
      this.emitChange('subDistrict', '')
      this.emitChange('postcode', '')
    },
    handleDistrictChange(value) {
      this.localSubDistrict = ''
      this.localPostcode = ''

      this.emitChange('district', value)
      this.emitChange('subDistrict', '')
      this.emitChange('postcode', '')
    },
    handleSubDistrictChange(value) {
      this.localPostcode = ''

      this.emitChange('subDistrict', value)
      this.emitChange('postcode', '')
    },
    emitChange(field, value) {
      this.$emit(`update:${field}`, value)
    },
  },
}
</script>

<style lang="stylus" scoped>
::v-deep .v-list-item__title
  white-space: normal
</style>
